<template>
  <a @click="handleChange" type="text" :class="['sider-trigger-a', collapsed ? 'collapsed' : '']">
    <Icon :type="icon" :size="size" class="mob-hide"/>
    <div class="icon-bars-btn" style="display:none">
        <span class="hamburger one"></span>
        <span class="hamburger two"></span>
        <span class="hamburger three"></span>
    </div>
  </a>
</template>
<script>
export default {
  name: 'siderTrigger',
  props: {
    collapsed: Boolean,
    icon: {
      type: String,
      default: 'navicon-round'
    },
    size: {
      type: Number,
      default: 26
    }
  },
  methods: {
    handleChange () {
      this.$emit('on-change', !this.collapsed)
    }
  }
}
</script>
<style lang="less">
@import './sider-trigger.less';
</style>
<style>
@media screen and (max-width:640px){
  .icon-bars-btn {
    position: fixed;
    left: 5%;
    width: 30px;
    height: 20px;
    margin-top: 5px;
    cursor: pointer;
    display:block!important;
  }

  .hamburger {
    width: 24px;
    left: 0;
    top: 8px;
    position: absolute;
    height: 2px;
    background: #333;
    transition: width .4s ease, -webkit-transform .4s ease;
    transition: transform .4s ease, width .4s ease;
    transition: transform .4s ease, width .4s ease, -webkit-transform .4s ease
  }

  .collapsed .hamburger.one {
    background: #333 !important;
    -webkit-transform: translateY(-6px) rotate(0);
    transform: translateY(-6px) rotate(0)
  }

  .collapsed .hamburger.two {
    background: #333 !important;
    -webkit-transform: translateY(6px) rotate(0);
    transform: translateY(6px) rotate(0)
  }

  .collapsed .hamburger.three {
    width:24px;
    -webkit-transform: translate(0) rotate(0);
    transform: translate(0) rotate(0)
  }

  .hamburger.one {
    background: #fff !important;
    -webkit-transform: translate(0) rotate(-45deg);
    transform: translate(0) rotate(-45deg)
  }

  .hamburger.two {
    background: #fff !important;
    -webkit-transform: translate(0) rotate(45deg);
    transform: translate(0) rotate(45deg);
  }

  .hamburger.three {
    width: 0px;
    -webkit-transform: translate(10px) rotate(0);
    transform: translate(10px) rotate(0)
  }
}

</style>
